/**
 * Global scheduled drops ordering — send time + optional per-country grouping.
 */

import type { FC } from 'react';
import { ArrowDownAZ } from 'lucide-react';

import { Button } from '@/components/ui';

import type { SortKey } from '../../shared/types';

export interface ScheduledSortToolbarProps {
  sortBy: SortKey | null;
  sortDir: 'asc' | 'desc';
  onToggleSendTimeOrder: () => void;
}

function isTimeSortActive(sortBy: SortKey | null): boolean {
  return sortBy == null || sortBy === 'time' || sortBy === 'scheduled';
}

export const ScheduledSortToolbar: FC<ScheduledSortToolbarProps> = ({
  sortBy,
  sortDir,
  onToggleSendTimeOrder,
}) => {
  const timeOrderActive = isTimeSortActive(sortBy);
  const latestFirst = timeOrderActive && sortDir === 'desc';
  const sendTimeLabel = !timeOrderActive ? 'Send time' : latestFirst ? 'Latest first' : 'Soonest first';
  const sendTimeAria = !timeOrderActive
    ? 'Sort scheduled drops by send time (choose order on next click)'
    : latestFirst
      ? 'Switch to soonest send time first'
      : 'Switch to latest send time first';
  return (
    <div className="flex flex-wrap items-center gap-1.5 border-l border-border/50 pl-2 sm:pl-3">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-8 gap-1.5 px-2 text-xs"
        onClick={onToggleSendTimeOrder}
        aria-label={sendTimeAria}
      >
        <ArrowDownAZ className="h-3.5 w-3.5 shrink-0" aria-hidden />
        {sendTimeLabel}
      </Button>
    </div>
  );
};
